var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXOchDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1601 1587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 800.5,
    cy: 793.5,
    r: 618.81,
    style: {
      fill: "#dee2de",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.36,1587c374.82-38.59,673.04-336.81,711.64-711.64h-98.82c-35.08,325.12-281.26,584.16-612.81,621v90.64Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,875.36c38.59,374.82,336.81,673.04,711.64,711.64v-90.64c-331.55-36.84-577.14-296.47-612.81-621H7Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594,711.64C1555.41,336.81,1257.19,38.59,882.36,0v90.64c331.55,36.84,577.14,296.47,612.81,621h98.82Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.64,0C343.81,38.59,45.59,336.81,7,711.64h98.82C140.91,386.52,387.08,127.47,718.64,90.64V0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.97,642.24c-37.86-32.18-85.63,16.06-55.42,55.73-46.11,57.96-191.58,242.53-238.23,303.08-15.69-35.21-180.19-367.58-239.76-487.9l8.05-8.06c12.54-12.54,15.64-20.27,15.64-39.01,1.11-24.65-11.82-39.64-31.12-49.84-70.26-25.59-108.15,64.77-45.5,102.01-25.34,101.18-80.33,330.94-105.42,432.02-.77,1.35-159.32-102.53-210.05-136.37,29.15-44.23-42.92-62.78-41.8-18.11-.98,17.87,19.78,28.66,33.76,21.67,8.33-11.7,52.62,105.87,76.3,151.69,60.37,134.06,93.19,203.4,97.98,207.73,10.22,8.18,22.18,2.11,24.46-10.84,2.66-7.57,35.97-137.2,46.59-174.13,69.94,47.35,197.91,153.83,268.1,190.08,17.25-1.86,25.92-26.74,57.74-64.71l43.8-57.89c8.28,15.48,16.18,29.9,34.67,65.01,19.66,33.12,24.96,56.89,37.47,51.4,44.37-87.64,145.8-374.05,190.07-466.24,38.09,2.43,60.22-39.58,32.66-67.34ZM530.26,1121.95c-40.54-67.5-143.38-253.82-168.87-302.16l-2.01-3.7c.27.18,4.48,2.93,4.49,2.93-3.8-.91,193.73,134.68,201.37,153.25-.93,7.74-33.9,148.45-34.98,149.68ZM861.99,1142.99c-.15.31-20.75-13.31-45.82-30.18-58.85-40.87-165.31-108.07-213.3-141.78,16.45-65.25,47.84-186.75,72.13-283.89,17.81-70.89,32.82-128.01,33.28-126.93,38.97,75.59,212.93,413.92,241.17,465.77-15.79,21.16-83.82,111.65-87.46,117.02ZM1176.83,802.76c-35.75,88.86-138.23,333.58-141.33,337.14-.31.46-5.11-9.45-32.35-66.56l-18.27-38.07c43.79-59.58,75.86-104.07,140.87-194.88,43.96-61.61,80.18-111.92,80.34-111.92.46,0-1.08,4.18-29.25,74.3Z",
    style: {
      strokeWidth: 0
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXOchDark);
export default __webpack_public_path__ + "static/media/xOCHDark.93c68b49f58ee8e83468f9dc49b2e436.svg";
export { ForwardRef as ReactComponent };